module.exports = __webpack_public_path__ + "static/media/shareFacebook.69babad7.svg";